export const getLocalTimezone = (): number => -new Date().getTimezoneOffset() / 60;
